import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import {
  getCoreDomain,
  customHeaders,
  CORE_API_ENTRYPOINT,
} from '@probatix/common/services/services.helpers'

// Define a service using a base URL and expected endpoints
export const productsApi = createApi({
  baseQuery: fetchBaseQuery({ baseUrl: getCoreDomain() }),
  endpoints: (builder) => ({
    getBaseProducts: builder.query<any, any>({
      query: ({ uuid }) => ({
        headers: customHeaders(),
        method: 'GET',
        url: `${CORE_API_ENTRYPOINT}/api/v0/base_products/${uuid}`,
      }),
    }),
    getProductByBaseProduct: builder.query<any, any>({
      query: ({ baseProductUUID, locationUUID }) => ({
        headers: customHeaders(),
        method: 'GET',
        url: `${CORE_API_ENTRYPOINT}/api/v0/location_product/${baseProductUUID}/${locationUUID}`,
      }),
    }),
  }),
  reducerPath: 'productsApi',
})

export const useGetBaseProducts = productsApi.endpoints.getBaseProducts.useLazyQuery
export const useGetProductByBaseProduct = productsApi.endpoints.getProductByBaseProduct.useLazyQuery
